import { NextRequest, NextResponse } from 'next/server'
import { DEFAULT_LANG_CODE } from './components/i18n/lang-context'

export const SOURCE_COOKIE_NAME = 'partner'
export const SOURCE_BANNER_CLOSED_COOKIE_NAME = 'partner_banner_closed'

export function middleware(req: NextRequest) {
  const url = req.nextUrl
  const pathname = url.pathname
  const source = url.searchParams.get(SOURCE_COOKIE_NAME)
  const hasLocalePrefix = /^\/(en|fr)(\/.*)?/.test(pathname)

  // Determine the response based on locale prefix
  let response: NextResponse

  if (!hasLocalePrefix) {
    // Rewrite to default language
    const rewriteUrl = url.clone()
    rewriteUrl.pathname = `/${DEFAULT_LANG_CODE}${pathname}`
    response = NextResponse.rewrite(rewriteUrl)
  } else {
    // Continue with the request
    response = NextResponse.next()
  }

  // Set cookie if from is present
  if (source) {
    response.cookies.set(SOURCE_COOKIE_NAME, source.toLowerCase(), {
      path: '/',
      httpOnly: false,
      sameSite: 'lax',
      secure: true,
      maxAge: 60 * 60 * 24 * 30 // 30 days
    }),
    response.cookies.set(SOURCE_BANNER_CLOSED_COOKIE_NAME, 'false', {
      path: '/',
      httpOnly: false,
      sameSite: 'lax',
      secure: true,
      maxAge: 60 * 60 * 24 * 30 // 30 days
    })
  }

  return response
}

// Only apply middleware to actual pages, not API/static files/assets
export const config = {
  matcher: ['/((?!api|_next/static|_next/image|favicon.ico|.*\\..*).*)']
}
